module.exports = __webpack_public_path__ + "img/beer_id-88.51d8ff1a.png";